import { render } from "./PassengerSelect.vue?vue&type=template&id=54a26264&scoped=true&lang=pug"
import script from "./PassengerSelect.vue?vue&type=script&lang=ts"
export * from "./PassengerSelect.vue?vue&type=script&lang=ts"

import "./PassengerSelect.vue?vue&type=style&index=0&id=54a26264&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54a26264"

export default script